<template>
  <v-dialog
    v-model="dialog"
    max-width="30rem"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-list-item-content v-on="on">
        <v-list-item-subtitle>Mot de passe</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <v-card>
      <v-card-title class="pa-1">
        <v-row dense no-gutters align="start" justify="end">
          <v-btn small icon text @click="dialog = !dialog">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-form ref="form" v-model="valid" @submit.prevent="changePassword">
        <v-card-text v-show="!loading">
          <v-row no-gutters>
            <v-text-field
              v-model="data.old_password"
              label="Ancien mot de passe"
              required
              :rules="[v => !!v || 'Veuillez saisir l\'ancien mot de passe']"
              :append-icon="showOld ? 'fa-eye' : 'fa-eye-slash'"
              @click:append="() => (showOld = !showOld)"
              counter
              :type="showOld ? 'text' : 'password'"
              name="old_password"
              autocomplete="off"
              dense
              filled
              class="no-before"
            ></v-text-field>
          </v-row>
          <v-row no-gutters>
            <v-text-field
              v-model="data.new_password"
              label="Nouveau mot de passe"
              required
              :rules="[v => !!v || 'Veuillez saisir le nouveau mot de passe']"
              :append-icon="showNew ? 'fa-eye' : 'fa-eye-slash'"
              @click:append="() => (showNew = !showNew)"
              counter
              :type="showNew ? 'text' : 'password'"
              name="new_password"
              autocomplete="off"
              dense
              filled
              class="no-before"
            ></v-text-field>
          </v-row>
        </v-card-text>
        <v-card-text v-show="loading">
          <v-col>
            <v-progress-linear indeterminate></v-progress-linear>
          </v-col>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-row align="center" justify="end" no-gutters>
            <v-btn
              color="success"
              small
              type="submit"
              :disabled="!valid || loading"
              :block="$vuetify.breakpoint.xsOnly"
              :large="$vuetify.breakpoint.smAndDown"
            >
              <v-icon left small>fa-check</v-icon>Soumettre
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
export default {
  name: "UserPasswordEditor",
  data() {
    return {
      loading: false,
      dialog: false,
      valid: false,
      showOld: false,
      showNew: false,
      data: {
        old_password: "",
        new_password: ""
      }
    };
  },
  methods: {
    async changePassword() {
      if (this.valid) {
        try {
          this.loading = true;
          this.$store.dispatch("startLoadingOverlay");
          await api.putUserPassword(this.data);
          this.$refs.form.reset();
          this.dialog = false;
        } finally {
          this.loading = false;
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    }
  }
};
</script>

<style></style>
